/* src/app/modules/print-cards/components/cards/backgrounds/business-cards-2x3/koan-business-card-stack-background/koan-business-card-stack-background.component.scss */
:host {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: stretch;
  box-sizing: border-box;
}
:host .main-content {
  flex: 1;
  background-color: #ece9e3;
}
/*# sourceMappingURL=koan-business-card-stack-background.component.css.map */
